import React,{useEffect} from 'react';
import { ReactSVG } from "react-svg";
import { useNavigate } from 'react-router-dom';

import './PageHeader.css';

function NavigateBackBtn({children}) {

  const navigate = useNavigate();

  return <div className='n-back' onClick={()=>{navigate(-1)}}>{children}</div>
}


/*
  pl.:

  <PageHeader parent_ref={this}  title={i18n.t('shoppingCartTitle')} custom_icons={[
    <ReactSVG className="edit" src="assets/images/edit_black.svg" onClick={() => this.edit()} />
  ]} />
*/

class PageHeader extends React.Component {

  constructor(props) {

    super(props);

    this.state = {
      custom_icons: props.custom_icons ? props.custom_icons : []
    };

  }

  render() {
    const { custom_icons} = this.state;
    const { title, isHistoryBack, no_back, no_close, callback: other_callback, underline, parent_ref } = this.props;

    const callback = () => {

      if(!!parent_ref && !!parent_ref.hide){

        parent_ref.hide();

      }else{

        if(other_callback) other_callback();

      }

    }

    let btn_back = null;

    if(isHistoryBack){
      btn_back = <NavigateBackBtn ><ReactSVG className="back" src="/assets/images/back.svg" onClick={callback} /></NavigateBackBtn>
    }else{
      btn_back = <ReactSVG className="n-back" src="/assets/images/back.svg" onClick={callback} />;
    }

    const btn_close = <ReactSVG className="close" src="/assets/images/close.svg" onClick={callback} />;
    
    return (
      <div className={`page_header ${no_back ? 'no_back' : ''} ${no_close ? 'no_close' : ''} ${underline ? 'underline' : ''}`}>
        <div>
          {!no_back ? btn_back : ''}

          <div className='center'>{title}</div>

          <div className="right">
            {custom_icons.map((icon, index) => <div key={index}>{icon}</div>) /* egyedileg megadott ReactSVG elemek kiíratása */}
            {!no_close ? btn_close : ''}
          </div>
        </div>
        {this.props.children ? <div className='bottom'>{this.props.children}</div> : ''}
      </div>
    );
  }
};

export default PageHeader;

